import { HTTP_CP_GetInbox_Response_InboxMessage } from '@api-new/reportingservice';
import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '@shared/models/app-state.model';
import { INBOX_FILTER } from '@shared/store/inbox/constants/inbox-filter';
import { inboxAdapter } from '@shared/store/inbox/inbox.reducer';
import { InboxState } from '@shared/store/inbox/inbox.state';
import { InboxFilterModel } from '@shared/store/inbox/models/inbox-filter.model';

const { selectAll, selectEntities } = inboxAdapter.getSelectors();

export const selectInboxState = createFeatureSelector<InboxState>('inbox');

export const selectInboxEntities = createSelector(selectInboxState, (state) => {
  return selectEntities(state);
});

export const selectInboxIsLoading = createSelector(selectInboxState, (state): boolean => state.loading);

export const selectFilteredInboxMessages = createSelector(selectInboxState, (state): HTTP_CP_GetInbox_Response_InboxMessage[] =>
  selectAll(state).filter((messages) =>
    state.filter != null ? INBOX_FILTER[state.filter].includes(messages.activityLog.entityType) : messages,
  ),
);

export const selectInboxUnreadCount = createSelector(selectInboxState, (state): number => state.unreadCount ?? 0);

export const selectInboxFilter = createSelector(selectInboxState, (state): InboxFilterModel => state.filter);

export const selectInboxMessageById = (id: string): MemoizedSelector<AppState, HTTP_CP_GetInbox_Response_InboxMessage> =>
  createSelector(selectInboxEntities, (entities) => entities[id]);
